import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.997 16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.662 2.752.862 5.57.83 8.091",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.003 16h31.994v.016c.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124.171 21.34-.029 18.521.003 16M9.24 3.002C6.524 3.073 4.346 5.284 4.346 8s2.178 4.927 4.892 4.998a5.4 5.4 0 0 1-1.875.335C4.4 13.333 2 10.945 2 8s2.401-5.333 5.364-5.333c.66 0 1.291.118 1.875.335",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m9.71 5.733-.59.41.208-.686-.574-.433.72-.014.236-.677.237.677.72.014-.574.433.208.685zm-2.704 2-.591.41.208-.686-.574-.433.72-.014.237-.677.236.677.72.014-.574.433.209.685zm1 3-.591.41.208-.686-.574-.433.72-.014.237-.677.236.677.72.014-.574.433.209.685zm3.333 0-.591.41.209-.686-.574-.433.72-.014.236-.677.237.677.72.014-.574.433.208.685zm1-3-.591.41.209-.686-.574-.433.72-.014.236-.677.237.677.72.014-.574.433.208.685z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagSgp = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagSgp_default = SvgFlagSgp;

export { FlagSgp_default as default };
